import {
    CLOSE_REWARD_EDITOR,
    CREATE_REWARD_ITEM,
    DELETE_REWARD_ITEM,
    GET_REWARD_ITEM,
    GET_REWARD_ITEMS,
    OPEN_REWARD_EDITOR,
    UPDATE_EDITOR_FIELD,
    UPDATE_REWARD_ITEM,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    rewardItems: [],
    rewardItem: {},
    rewardEditor: {
        open: false,
        id: '',
    },
};
const rewardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_REWARD_ITEM: {
            return {
                ...state,
                rewardItems: [...state.rewardItems, action.rewardItem],
            };
        }
        case GET_REWARD_ITEM: {
            return {
                ...state,
                rewardItem: {
                    ...action.rewardItem,
                    loyaltyPrizeItems: action.rewardItem.loyaltyPrizeItems.map(
                        (item) => item.loyaltyPrizeItemId
                    ),
                    ...(action.rewardItem.startDate && {
                        startDate: action.rewardItem.startDate,
                    }),
                    ...(action.rewardItem.endDate && {
                        endDate: action.rewardItem.endDate,
                    }),
                },
            };
        }
        case GET_REWARD_ITEMS: {
            return {
                ...state,
                rewardItems: action.rewardItems,
            };
        }
        case OPEN_REWARD_EDITOR: {
            return {
                ...state,
                rewardEditor: {
                    ...state.rewardEditor,
                    open: true,
                    id: action.id,
                },
            };
        }
        case CLOSE_REWARD_EDITOR: {
            return {
                ...state,
                rewardEditor: {
                    ...state.rewardEditor,
                    open: false,
                },
                rewardItem: {},
            };
        }
        case UPDATE_EDITOR_FIELD: {
            return {
                ...state,
                rewardItem:
                    action.field === 'promotionType'
                        ? { promotionType: action.value }
                        : { ...state.rewardItem, [action.field]: action.value },
            };
        }
        case DELETE_REWARD_ITEM: {
            return {
                ...state,
                rewardItem: {},
                rewardItems: state.rewardItems.filter(
                    (item) => item.loyaltyRewardId !== action.id
                ),
            };
        }
        case UPDATE_REWARD_ITEM: {
            return {
                ...state,
                rewardItems: state.rewardItems.map((reward) =>
                    reward.loyaltyRewardId === action.rewardItem.loyaltyRewardId
                        ? action.rewardItem
                        : reward
                ),
            };
        }
        default: {
            return state;
        }
    }
};

export default rewardReducer;
